<div
  class="message-wrapper or-d-flex"
  [ngClass]="{
    'or-justify-content-end': isOwnMessage(),
    'or-justify-content-start': !isOwnMessage(),
    'gap-between-groups': isLastInGroup(),
    'gap-within-group': !isLastInGroup()
  }">
  @if (!isOwnMessage() && !message().isDeleted) {
    <div class="avatar-column or-mr-8-px">
      @if (showHeader()) {
        <lib-or-avatar
          [avatarUrl]="message().userImage"
          [initials]="message().userName"
          [avatarSize]="'sm'"
          [rightMargin]="false">
        </lib-or-avatar>
      } @else {
        <div class="avatar-placeholder"></div>
      }
    </div>
  }
  @if (message().isDeleted) {
    <div class="deleted-message">
      <ion-icon name="ban-outline" class="deleted-icon"></ion-icon>
      <span class="or-text-sm or-color-secondary-2">Ta wiadomość została usunięta</span>
    </div>
  } @else {
    <div class="message-container">
      @if (showActions()) {
        <div class="inline-actions" [ngClass]="isOwnMessage() ? 'actions-right' : 'actions-left'">
          @if (showDeleteConfirm()) {
            <div class="delete-confirm-row" (click)="$event.stopPropagation()">
              <span class="confirm-text">Usunąć wiadomość?</span>
              <button class="action-btn confirm-btn" type="button" (click)="confirmDelete($event)">Tak</button>
              <button class="action-btn cancel-btn" type="button" (click)="cancelDelete($event)">Nie</button>
            </div>
          }
          @if (!showDeleteConfirm() && showMoreActions()) {
            <div class="more-actions-row" (click)="$event.stopPropagation()">
              <button class="action-btn more-btn" type="button" (click)="toggleMoreActions($event)">
                <ion-icon name="chevron-back"></ion-icon>
              </button>
              <button class="action-btn text-btn" type="button" (click)="quoteMessage()">
                <ion-icon name="arrow-undo-outline"></ion-icon>
                <span>Odpowiedz</span>
              </button>
              @if (message().text) {
                <button class="action-btn text-btn" type="button" (click)="copyText()">
                  <ion-icon name="copy-outline"></ion-icon>
                  <span>Kopiuj</span>
                </button>
              }
              @if (isOwnMessage() && message().text) {
                <button class="action-btn text-btn" type="button" (click)="editMessage()">
                  <ion-icon name="create-outline"></ion-icon>
                  <span>Edytuj</span>
                </button>
              }
              @if (isOwnMessage()) {
                <button class="action-btn icon-btn delete-btn" type="button" (click)="showDeleteConfirmation($event)">
                  <ion-icon name="trash-outline"></ion-icon>
                </button>
              }
            </div>
          }
          @if (!showDeleteConfirm() && !showMoreActions()) {
            <div class="reactions-row" (click)="$event.stopPropagation()">
              @for (reaction of reactionTypes; track reaction.type) {
                <button class="action-btn reaction-btn" type="button" (click)="onQuickReaction(reaction.type)">
                  {{ reaction.emoji }}
                </button>
              }
              <button class="action-btn more-btn" type="button" (click)="toggleMoreActions($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
              </button>
            </div>
          }
        </div>
      }

      <div
        class="message-content"
        [ngClass]="isOwnMessage() ? 'own-message' : 'other-message'"
        (touchstart)="onTouchStart()"
        (touchend)="onTouchEnd()"
        (touchmove)="onTouchMove()">
        @if (showHeader()) {
          <div class="message-sender or-text-sm or-mb-2-px" [ngClass]="isOwnMessage() ? 'or-text-align-end' : ''">
            {{ message().userName }}
          </div>
        }

        <div
          class="message-body"
          libSwipeReply
          [libSwipeReplyDisabled]="showActions()"
          [libSwipeReplyDirection]="isOwnMessage() ? 'left' : 'right'"
          (swipeReply)="quoteMessage()">
          @if (message().quotedMessage; as quoted) {
            <div class="quoted-message" [ngClass]="isOwnMessage() ? 'quoted-own' : 'quoted-other'">
              <div class="quoted-user or-note-sm">{{ quoted.userName }}</div>
              @if (quoted.imageUrl) {
                <img [src]="quoted.imageUrl" alt="Zdjęcie" class="quoted-image" />
              }
              @if (quoted.text) {
                <div class="quoted-text or-text-sm">{{ quoted.text }}</div>
              }
            </div>
          }
          @if (message().imageUrls.length > 0) {
            <div class="message-images or-mb-4-px" [ngClass]="isOwnMessage() ? 'or-d-flex or-justify-content-end' : ''">
              @for (imageUrl of message().imageUrls; track imageUrl) {
                <img [src]="imageUrl" alt="Załącznik" class="message-image" (click)="openImagePreview(imageUrl)" />
              }
            </div>
          }
          @if (message().text) {
            <div
              class="message-bubble"
              [ngClass]="{
                'bubble-own': isOwnMessage(),
                'bubble-other': !isOwnMessage(),
                'bubble-own-single': isOwnMessage() && position() === MessagePosition.SINGLE,
                'bubble-own-first': isOwnMessage() && position() === MessagePosition.FIRST,
                'bubble-own-middle': isOwnMessage() && position() === MessagePosition.MIDDLE,
                'bubble-own-last': isOwnMessage() && position() === MessagePosition.LAST,
                'bubble-other-single': !isOwnMessage() && position() === MessagePosition.SINGLE,
                'bubble-other-first': !isOwnMessage() && position() === MessagePosition.FIRST,
                'bubble-other-middle': !isOwnMessage() && position() === MessagePosition.MIDDLE,
                'bubble-other-last': !isOwnMessage() && position() === MessagePosition.LAST
              }">
              <span
                class="or-text-md"
                [ngClass]="isOwnMessage() ? 'or-color-white' : ''"
                [innerHTML]="message().text | messageTextFormat: message().mentionedUsers : currentUserId()"></span>
            </div>
          }
        </div>

        @if (message().reactions.length > 0) {
          <div class="reactions-wrapper" [ngClass]="isOwnMessage() ? 'reactions-wrapper-own' : ''">
            <div class="reactions-container" [ngClass]="isOwnMessage() ? 'or-d-flex or-justify-content-end' : ''">
              @for (reaction of message().reactions; track reaction.type) {
                <button
                  class="reaction-badge"
                  [ngClass]="reaction.ownReaction ? 'reaction-own' : ''"
                  (click)="onReactionClick(reaction)"
                  (touchstart)="onReactionTouchStart($event)"
                  (touchend)="onReactionTouchEnd()"
                  (touchmove)="onReactionTouchMove()">
                  <span class="reaction-emoji">{{ getReactionEmoji(reaction.type) }}</span>
                  <span class="reaction-count">{{ reaction.count }}</span>
                </button>
              }
            </div>
            @if (showReactionDetails()) {
              <div class="reaction-details-popover" [ngClass]="isOwnMessage() ? 'popover-right' : 'popover-left'">
                <div class="reaction-details-list">
                  @for (reaction of message().reactions; track reaction.type) {
                    @for (user of reaction.users; track user.id) {
                      <div class="reaction-details-user">
                        <span class="reaction-details-emoji">{{ getReactionEmoji(reaction.type) }}</span>
                        <span class="or-text-sm">{{ user.name }}</span>
                      </div>
                    }
                  }
                </div>
              </div>
            }
          </div>
        }
        @if (isLastInGroup()) {
          <div
            class="message-time or-note-sm or-color-secondary-2 or-mt-2-px"
            [ngClass]="isOwnMessage() ? 'or-text-align-end' : ''">
            {{ formattedTime() }}
          </div>
        }
      </div>
    </div>
  }
</div>
